import { atom } from 'jotai';

export interface Sound {
  enabled: boolean;
  volume: number;
}

export const soundAtom = atom<Sound>({ enabled: true, volume: 0.35 });
